// These constants affect the rarely deployed "gdpr" webpack bundle, keep them here in its own file separated from the more frequently changed files elsewhere in iron/common

/**
 * Since we load 3rd party script on mixpanel like visual weboptimizer and likes
 * They use localstorage for tracking related info
 * STORAGE_ALLOWLIST restricts what can be used in localStorage/sessionStorage when user is in GDPR mode.
 */
export const STORAGE_ALLOWLIST = [
  `banners`,
  `dismissible-persistence-banner-key`,
  `sessionid`,
  `csrftoken`,
  `__mp_opt_in_out`,
  `mp_optout`,
  `mp_user`,

  // MRFE 112
  `_mkto_trk`,
  `mp__origin`,
  `mp__origin_referrer`,
  `mixpanel_utm_campaign`,
  `mixpanel_utm_content`,
  `mixpanel_utm_medium`,
  `mixpanel_utm_source`,
  `mixpanel_utm_term`,

  // UI language preference (iron/common/i18n/index.ts); functional preference, no personal data
  `selectedLanguage`,

  // from iron/common/report/constants.ts LocalStorageKey enum
  // we can't use const enums because webpack compiles with --isolatedModules
  `$mp_message_targeting_from_explore`,
  `$mp_features_cache`,
  `$mp_last_opened_dashboard`,
  `$mp_recently_viewed_dashboards`,
  `$mp_dark_mode`,
  `$mp_date_picker_recents`,
  // LocalStorageKey.Panel
  `$mp_panel`,
  `$mp_sidebar`,
  `$mp_sidenav`,
  `$mp_global_sidenav`,
  `$mp_current_project_client_cache`,
  `$mp_dismiss_tooltip_tour`,
  `$mp_onboarding_checklist`,
  `$mp_cross_project`,
  // LocalStorageKey.SearchedTextPersistedState
  `$mp_browse_search_text`,
  // LocalStorageKey.AgentIntelligenceConversationDetails: display preferences of the conversation detail
  // page, such as which transcript cards to show; no personal data
  `$mp_agent_intelligence_conversation_details`,
  `$mp_agent_intelligence_conversations`,
  // LocalStorageKey.OrganizationId
  `$mp_org`,
  `$mp_onboarding_questionnaire_skips`,
  `$mp_onboarding_questionnaire_dismissed`,
  `$mp_metrics_beta_button`,
  `$mp_homepage_dashboard`,
  `$mp_react_table_selection`,
  `$mp_content_sidenav_collapsed`,
  `$mp_sendbird_help_chat_opened`,
  `$mp_seen_replay_ids`,
];

/**
 * Known namespace prefixes used by NamespacedLocalStorage.
 * Keys are stored as `namespace:subkey` in localStorage.
 *
 * Use these constants when constructing NamespacedLocalStorage instances
 * so that the namespace values stay consistent with the GDPR allowlist.
 */
export const NamespacedStorageKey = {
  Banners: `banners`,
  ExploreTablePersistence: `explore-table-persistence`,
  Impact: `impact`,
  FeatureFlagQaTesters: `feature-flag-qa-testers`,
  Search: `search`,
  OrganizationId: `$mp_org`,
  EventsMenu: `events-menu`,
  PropertiesMenu: `properties-menu`,
  FormulasMenu: `formulas-menu`,
  BehaviorsMenu: `behaviors-menu`,
  Comments: `$mp_comments`,
} as const;

/**
 * Namespace prefixes that are always allowed regardless of GDPR status.
 * If a localStorage key starts with any of these prefixes followed by `:`,
 * it is allowed regardless of GDPR opt-out status.
 */
export const STORAGE_NAMESPACE_PREFIX_ALLOWLIST = Object.values(NamespacedStorageKey);
